import {
  CollabCardWidth,
  CollabCoverField,
  CollabCoverFieldType,
  CollabLayoutType,
  CollabViewSortType,
  DatabaseViewJSON,
  MutableView,
  View,
} from '@databases/model/views/view';
import { MutableCollabFilter } from '@databases/model/views/view-filter';

export class YAllEntriesView implements View, MutableView {
  get name(): string {
    return 'All entries';
  }

  get sort(): CollabViewSortType | undefined {
    return undefined;
  }
  set sort(data) {
    // no-op
  }

  get layoutType(): CollabLayoutType {
    return CollabLayoutType.TABLE;
  }
  set layoutType(data) {
    // no-op
  }

  get cardWidth(): CollabCardWidth {
    return CollabCardWidth.MEDIUM;
  }
  set cardWidth(data) {
    // no-op
  }

  get coverField(): CollabCoverField {
    return { type: CollabCoverFieldType.Default };
  }
  set coverField(data) {
    // no-op
  }

  get groupFieldId(): string | undefined {
    return undefined;
  }
  set groupFieldId(data) {
    // no-op
  }

  get fields(): Readonly<Record<string, boolean> | undefined> {
    return undefined;
  }

  get filter(): MutableCollabFilter | undefined {
    return undefined;
  }

  toJSON(): DatabaseViewJSON {
    return {
      name: this.name,
      sort: this.sort,
      layoutType: this.layoutType,
      cardWidth: this.cardWidth,
      coverField: this.coverField,
      groupFieldId: this.groupFieldId,
      fields: this.fields,
      filter: undefined,
    };
  }

  applyNameDelta() {
    // no-op
  }

  setFieldVisibility() {
    // no-op
  }

  resetFieldVisibility() {
    // no-op
  }

  removeFieldVisibilityField() {
    // no-op
  }

  setFilter(): MutableCollabFilter {
    throw new Error('All entries view is not mutable.');
  }

  clearFilter() {
    // no-op
  }
}
